import { useSchedulerContext } from '@contexts/scheduler';
import { SchedulerGridRowProps } from './types';
import { SchedulerGridForeman } from './foreman';
import { SchedulerGridCell } from '../cell';
import { SchedulerGridCellSegment } from './segment';
import { cn } from '@utils/cn';
import { getSchedule, isEnd, isStart } from './helpers';

export const SchedulerGridRow = ({
  data,
  first,
  last,
  lastRow,
  foreman,
  withoutTeam,
}: SchedulerGridRowProps) => {
  const { hours, modal, segment } = useSchedulerContext();

  return (
    <>
      <SchedulerGridForeman data={foreman} first={first} last={last} lastRow={lastRow} />
      {hours.map((hour, i) => (
        <SchedulerGridCell
          key={`scheduler-grid-cell-${i}`}
          className={cn([
            'scheduler-grid-cell',
            !lastRow || modal ? 'border-b' : 'after:hidden',
            !last && 'border-b-transparent',
            (withoutTeam || foreman.discardedAt) && 'bg-neutral-50 bg-opacity-50',
            i === hours.length - 1 && 'border-r',
          ])}>
          {hour.map((el) => (
            <SchedulerGridCellSegment
              key={`scheduler-grid-cell-${i}-segment-${el.getTime()}`}
              date={el}
              start={data.length ? isStart(el, data) : false}
              end={data.length ? isEnd(el, segment.length, data) : false}
              data={data.length ? getSchedule(el, segment.length, data) : undefined}
              last={last}
              foreman={foreman}
              style={{ width: segment.width }}
            />
          ))}
        </SchedulerGridCell>
      ))}
    </>
  );
};
